import { render, staticRenderFns } from "./AddDialog.vue?vue&type=template&id=2d40764c&scoped=true&"
import script from "./AddDialog.vue?vue&type=script&lang=js&"
export * from "./AddDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddDialog.vue?vue&type=style&index=0&id=2d40764c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d40764c",
  null
  
)

export default component.exports